import { render, staticRenderFns } from "./EnergyConsumption.vue?vue&type=template&id=97ac6d36&"
import script from "./EnergyConsumption.vue?vue&type=script&lang=js&"
export * from "./EnergyConsumption.vue?vue&type=script&lang=js&"
import style0 from "./EnergyConsumption.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports